import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  VEHICLES_FEATURE_KEY,
  vehiclesAdapter,
  VehiclesPartialState,
  VehicleState,
} from './vehicles.reducer';

// Lookup the 'Vehicles' feature state managed by NgRx
export const getVehiclesState = createFeatureSelector<
  VehiclesPartialState,
  VehicleState
>(VEHICLES_FEATURE_KEY);

const { selectAll, selectEntities } = vehiclesAdapter.getSelectors();

export const getVehiclesLoaded = createSelector(
  getVehiclesState,
  (state: VehicleState) => state.loaded
);

export const getVehiclesError = createSelector(
  getVehiclesState,
  (state: VehicleState) => state.error
);

export const getAllVehicles = createSelector(
  getVehiclesState,
  (state: VehicleState) => selectAll(state)
);

export const getVehiclesEntities = createSelector(
  getVehiclesState,
  (state: VehicleState) => selectEntities(state)
);

export const getSelectedVehicleId = createSelector(
  getVehiclesState,
  (state: VehicleState) => state.selectedId
);

export const getSelectedVehicle = createSelector(
  getVehiclesEntities,
  getSelectedVehicleId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getDrivers = createSelector(
  getVehiclesState,
  (state: VehicleState) => state.drivers
);

export const getSelectedDriver = createSelector(
  getVehiclesState,
  (state: VehicleState) =>
    state.selectedAdministratorId &&
    state.drivers.filter((a) => a.id === state.selectedAdministratorId).length
      ? state.drivers.filter((a) => a.id === state.selectedAdministratorId)[0]
      : null
);

export const getRoles = createSelector(
  getVehiclesState,
  (state: VehicleState) => state.roles
);

export const getVehiclesNextPage = createSelector(
  getVehiclesState,
  (state: VehicleState) => state.nextPage
);
export const getPagination = createSelector(
  getVehiclesState,
  (state: VehicleState) => state.pagination
);

export const getPerPage = createSelector(
  getVehiclesState,
  (state: VehicleState) => state.perPage
);
